import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Navbar      from './components/Navbar.jsx'
import Footer      from './components/Footer.jsx'
import Home        from './pages/Home.jsx'
import Servers     from './pages/Servers.jsx'
import Contact     from './pages/Contact.jsx'
import Privacy     from './pages/Privacy.jsx'
import DeployRoute from './pages/DeployRoute.jsx'
import { useServerStats } from './hooks/useServerStats.js'
import { SERVERS } from './constants.js'
import styles from './App.module.css'

function Layout({ children, stats, totalBots, onlineCount, refresh, refreshing, lastRefresh }) {
  return (
    <div className={styles.app}>
      <div className={styles.gridBg} />
      <div className={styles.scanline} />
      <Navbar
        totalBots={totalBots}
        onlineCount={onlineCount}
        serverCount={SERVERS.length}
      />
      <main className={styles.main}>
        {children}
      </main>
      <Footer
        totalBots={totalBots}
        onlineCount={onlineCount}
        serverCount={SERVERS.length}
      />
    </div>
  )
}

export default function App() {
  const { stats, refreshing, lastRefresh, refresh, totalBots, onlineCount } = useServerStats()

  return (
    <BrowserRouter>
      <Layout stats={stats} totalBots={totalBots} onlineCount={onlineCount} refresh={refresh} refreshing={refreshing} lastRefresh={lastRefresh}>
        <Routes>
          <Route path="/"           element={<Home serverStats={stats} totalBots={totalBots} onlineCount={onlineCount} />} />
          <Route path="/saviya-x/dep" element={<DeployRoute serverStats={stats} />} />
          <Route path="/servers"    element={<Servers stats={stats} refresh={refresh} refreshing={refreshing} lastRefresh={lastRefresh} />} />
          <Route path="/contact"    element={<Contact />} />
          <Route path="/privacy"    element={<Privacy />} />
          <Route path="*"           element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  )
}
